<template>
  <div>
    <!-- グローバルナビゲーション -->
    <v-app-bar app color="#ffffff">
      <v-app-bar-nav-icon @click="drawer = !drawer" style="display:none;"> </v-app-bar-nav-icon>
      <v-toolbar-title class="px-0 pl-2">
        <template v-if="toolbarTitle != ''">
          <div class="scn-name">{{ toolbarTitle }}</div>
        </template>
        <template v-else>
          <v-img src="@/assets/img/aozora-mrk.png" max-width="200px"></v-img>
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div>
        <v-img src="../assets/img/touki-tqs-title.png"  @click="transScreen('トップページ')"></v-img>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  props: ["propScreenTitle"],
  data: () => ({
    transViewPath: "",
  }),
  computed: {
    toolbarTitle() {
      // console.log(this.propScreenTitle);
      return this.propScreenTitle;
    }
  },
  methods: {
    transScreen: function(name) {
      // 遷移先
      if (name == 'トップページ') {  
        this.transViewPath = this.$router.resolve({ name: "PSS100" }).href;
        // 遷移
        this.$router.push(this.transViewPath).catch(()=>{});
      } 
    }
  }
};
</script>

<style scoped>
.scn-name {
  font-size: x-large;
  color: #f17a35;
}
@media screen and (max-width: 750px) {
  .scn-name {
    font-size: small;
  }
}
</style>